var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiretruck = function SvgFiretruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m21.508 11.675-3.433-3.433A.834.834 0 0 0 17.483 8h-2.15a.833.833 0 0 0-.833.833V10.5H6.85l10.558-5.942a.833.833 0 0 0-.816-1.45L3.4 10.5A1.667 1.667 0 0 0 2 12.167v4.166A1.667 1.667 0 0 0 3.667 18H4.5a2.5 2.5 0 0 0 5 0h5a2.5 2.5 0 0 0 5 0h.833A1.667 1.667 0 0 0 22 16.333v-3.475a1.666 1.666 0 0 0-.492-1.183"
  })));
};
export default SvgFiretruck;